import React, { Component } from 'react';
import './style.css';
import { Link } from "react-router-dom";
import Header from './../../header/header';
import Footer from './../../footer/footer';
import { horoscopeName_en, horoscopeDate_en } from './../../../../utils/horoscope_en';
import { horoscopeName_es, horoscopeDate_es } from './../../../../utils/horoscope_es';
import { horoscopeName_gr, horoscopeDate_gr } from './../../../../utils/horoscope_gr';
import { horoscopeName_ee, horoscopeDate_ee } from './../../../../utils/horoscope_ee';
import { horoscopeName_nl, horoscopeDate_nl } from './../../../../utils/horoscope_nl';
import { horoscopeName_fr, horoscopeDate_fr } from './../../../../utils/horoscope_fr';
import { horoscopeName_ar, horoscopeDate_ar } from './../../../../utils/horoscope_ar';
import { horoscopeName_hu, horoscopeDate_hu } from './../../../../utils/horoscope_hu';
import { horoscopeName_no, horoscopeDate_no } from './../../../../utils/horoscope_no';
import { horoscopeName_pl, horoscopeDate_pl } from './../../../../utils/horoscope_pl';
import { horoscopeName_vn, horoscopeDate_vn } from './../../../../utils/horoscope_vn';
import { horoscopeName_se, horoscopeDate_se } from './../../../../utils/horoscope_se';
import { horoscopeName_cy, horoscopeDate_cy } from './../../../../utils/horoscope_cy';
import { horoscopeName_ro, horoscopeDate_ro } from './../../../../utils/horoscope_ro';
import Modal from "react-responsive-modal";
import Tarot from './../tarot/tarot';
import Coffeecupsection from './../coffeecupreading/coffeeCupSection'
import DownloadApk from './../DownloadApk/downloadApk'
import { FormattedMessage } from 'react-intl';
import Particle from './../../../../utils/particle';
import './../../../assets/css/style.css';
import { sendData } from '../../../../analytics/sendData';
import {config} from './../../../../utils/domain_config'
import { reading_no } from './../../../../utils/reading_no'


class Horoscopes extends Component {

    state = {
        isModalOpen: true
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        sendData('', '', 'viewed', { page: "homepage" });
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        if(this.state.isModalOpen && (countryCode.countryCode == 'no' && new URL(window.location.href).searchParams.get('source') == 'tq_page')){
            let element = document.body.getElementsByClassName('header-fix')[0]
            element.style.filter = 'blur(5px)'
        }
    }
    getCountry = () => {
        if (window.location.hostname == 'es.mobioastro.com') {
            return 'mexico';
        } else if (window.location.hostname == 'localhost') {
            return 'mexico';
        } else {
            '';
        }
    }
    horoscopeList = () => {
        let horoscopeName = [], horoscopeDate = [];
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        console.log("countryCode",typeof(countryCode.countryCode))
        if (countryCode.countryCode === 'es' || countryCode.countryCode === 'mx') {
            console.log("test")
            horoscopeName = horoscopeName_es;
            horoscopeDate = horoscopeDate_es;
        } else if (countryCode.countryCode === 'gr'){
            horoscopeName = horoscopeName_gr;
            horoscopeDate = horoscopeDate_gr;
        }else if (countryCode.countryCode === 'ee'){
            horoscopeName = horoscopeName_ee;
            horoscopeDate = horoscopeDate_ee;
        }else if (countryCode.countryCode === 'nl'){
            horoscopeName = horoscopeName_nl;
            horoscopeDate = horoscopeDate_nl;
        }
        else if (countryCode.countryCode === 'fr'){
            horoscopeName = horoscopeName_fr;
            horoscopeDate = horoscopeDate_fr;
        }
        else if (countryCode.countryCode === 'eg' || countryCode.countryCode === 'ps' || countryCode.countryCode === 'jo'){
            horoscopeName = horoscopeName_ar;
            horoscopeDate = horoscopeDate_ar;
        }
        else if (countryCode.countryCode === 'hu'){
            horoscopeName = horoscopeName_hu;
            horoscopeDate = horoscopeDate_hu;
        }
        else if (countryCode.countryCode === 'no'){
            horoscopeName = horoscopeName_no;
            horoscopeDate = horoscopeDate_no;
        }
        else if (countryCode.countryCode === 'pl') {
            horoscopeName = horoscopeName_pl;
            horoscopeDate = horoscopeDate_pl;
        }
        else if (countryCode.countryCode === 'vn') {
            horoscopeName = horoscopeName_vn;
            horoscopeDate = horoscopeDate_vn;
        }
        else if (countryCode.countryCode === 'se') {
            horoscopeName = horoscopeName_se;
            horoscopeDate = horoscopeDate_se;
        }
        else if (countryCode.countryCode === 'rs') {
            horoscopeName = horoscopeName_cy;
            horoscopeDate = horoscopeDate_cy;
        }
        else if (countryCode.countryCode === 'ro') {
            horoscopeName = horoscopeName_ro;
            horoscopeDate = horoscopeDate_ro;
        }
        else {
            horoscopeName = horoscopeName_en;
            horoscopeDate = horoscopeDate_en;
        }
        return (
            <div className="box-items">
                {
                    horoscopeName.map((rowData, index) => {
                        return (
                            <div className="item" key={index}>
                                <Link to={{ pathname: '/horoscopeDetail', state: { id: (index) } }}>
                                    <div className="item-img"> <img src={require('./../../../assets/images/horoscopes/horoscope-icon-' + (index) + '.png')} alt="" /></div>
                                    <div className="item-caption">
                                        <p className="text-bold">{rowData}</p>
                                        <p className="offset-top-0">{horoscopeDate[index]}</p>
                                    </div>
                                </Link>
                            </div>
                        )

                    })
                }
            </div>
        )

    }

    displayReadings = () => {
        if(sessionStorage.getItem('rid') == null){
            let val = Math.floor(Math.random()*5)
            sessionStorage.setItem('rid', val)
            return reading_no.readings[val].text
        }
        else{
            let rid = parseInt(sessionStorage.getItem('rid'))
            return reading_no.readings[rid].text
        }
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false
        })
        let element = document.body.getElementsByClassName('header-fix')[0]
        element.removeAttribute('style')
    }

    onClickWhatsappIcon = () => {
        sendData('', '', 'WA chat clicked');
        window.open('https://wa.me/12028528006?text=Hello')
    }

    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));    
        const uid = JSON.parse(sessionStorage.getItem('uid')).uid;
        let styleObject = null
        if(this.state.isModalOpen && (countryCode.countryCode == 'no' && new URL(window.location.href).searchParams.get('source') == 'tq_page')){ 
            styleObject={
                filter: 'blur(5px)'
            }
        }
        return (
            <div>
            { (countryCode.countryCode == 'no' && new URL(window.location.href).searchParams.get('source') == 'tq_page')
                ?
                (
                    <div>
                        <Modal open={this.state.isModalOpen} 
                        onClose={this.closeModal} 
                        classNames={{
                            modal: "customModal",
                            closeButton:"customCloseButton",
                            closeIcon:"customCloseIcon"       
                        }}
                        focusTrapped={true}
                        center>
                            <div className="container">
                                <div className="row d-flex justify-content-center mb-3">
                                    <img src={require('./../../../assets/images/saturn.png')} className="modalIcon" />
                                </div>
                                <div className="row d-flex justify-content-center">
                                    <div className="modalHeader text-center">
                                        {reading_no.title}
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-center">
                                    <div className="modalContent">
                                    {this.displayReadings()}
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-center">
                                    <button className="modalButton" onClick={this.closeModal}>
                                    <FormattedMessage id="exploremore" defaultMessage="EXPLORE MORE"/>
                                    </button>
                                </div>                                
                            </div>
                        </Modal>
                    </div>
                )
                :
                null
            }
            <div className="page" style={styleObject}>
                <Header />
                <Particle />
                
                {(config.subDomain == 'kw' || config.subDomain == 'bh')? '' 
                :
                    <div className="margin-tarot">
                        <Tarot />
                    </div>
                }
                    {(countryCode.countryCode == 'ie' || countryCode.countryCode == 'no') && 
                        <button className="whatsapp-button" onClick={this.onClickWhatsappIcon}>
                            <img src={require('./whatsapp.png')} />
                        </button>
                }
                
                
                <div className={(config.subDomain == 'kw' || config.subDomain == 'bh') ? "margin-horoscope-no-tarot" : "margin-horoscope"}>
                    <div className="shell text-center">
                        <div className="range range-xs-center">
                            <div className="cell-xs-12" >
                                <h2><FormattedMessage id="main.horoscope.title"
                                    defaultMessage="Daily horoscopes for you"
                                    description=""
                                    values={{}} /></h2>
                            </div>
                            <div className="cell-xs-12 cell-md-9 offset-top-30" style={{ marginTop: '30px' }}>
                                {this.horoscopeList()}
                            </div>
                        </div>
                    </div>
                </div>

                {countryCode.countryCode==='gr' ?
                <div className='margin-bottom-coffee'>
                    <Coffeecupsection />
                </div>:null
                }
                {config.subDomain==='pl' ?
                <div className='margin-bottom-coffee'>
                    <DownloadApk />
                </div>
                :null
                }
                {config.subDomain==='gr' ?
                <div className='margin-bottom-coffee'>
                    <DownloadApk />
                </div>
                :null
                }
                {((countryCode.countryCode == 'es' || countryCode.countryCode == 'mx' || 
                countryCode.countryCode == 'gr' || countryCode.countryCode == 'fr' || 
                countryCode.countryCode == 'ie' || countryCode.countryCode == 'eg' || 
                countryCode.countryCode == 'ps' || countryCode.countryCode == 'jo' || 
                countryCode.countryCode == 'no' || countryCode.countryCode == 'pl' ||
                countryCode.countryCode == 'za' || countryCode.countryCode == 'se' || countryCode.countryCode == 'ro' || (countryCode.countryCode == 'en' && window.location.host.includes('eg'))) && config.subDomain!=='be')
                ?
                    <Footer country={countryCode.countryCode} />
                :
                null
                } 
        {(countryCode.countryCode == 'explore' || countryCode.countryCode == 'no') && 
        <section className="section-xs-bottom-95 " style={{zIndex:1}}>
          <div style={{fontSize:'0'}} className="range range-condensed range-xs-center">
            <div className="cell-xs-10 cell-sm-8 cell-md-4 section-relative bg-image bg-image-3 bg-image-overlay bg-image-hover">
              
              <div className="box-offer box-offer-variant-2 context-dark">
                <div className="box-offer-caption">
                  <div className="img-icon"></div>
                  <h1 style={{fontSize:'60px'}} className="offset-top-10 offset-xs-top-20 offset-md-top-10 offset-xl-top-20"><FormattedMessage id="hotdate"
                                    defaultMessage="Hot date? Drama?"/><br></br> <FormattedMessage id="lonely"
                                defaultMessage="Lonely night?"/></h1>
                  <p className="text-big text-bold offset-top-5 offset-xs-top-10 offset-md-top-5 offset-xl-top-10"><FormattedMessage id="imgdesc1"
                                    defaultMessage="Daily Love Tarot Card Reading"/></p>
                  <a href={`/dailyLove?uid=${uid}`} className="swapbtn btn btn-white-outline offset-top-5 offset-xs-top-13 offset-md-top-5 offset-xl-top-13"><FormattedMessage id="knowmore"
                                    defaultMessage="Know More"/></a>
                </div>
              </div>
            </div>
            <div className="cell-xs-10 cell-sm-8 cell-md-4 offset-xs-top-30 offset-md-top-0 section-relative bg-image bg-image-4 bg-image-overlay bg-image-hover">
             
              <div className="box-offer box-offer-variant-2 context-dark">
                <div className="box-offer-caption">
                  <div className="img-icon"></div>
                  <h1 style={{fontSize:'60px'}} className="offset-top-10 offset-xs-top-20 offset-md-top-10 offset-xl-top-20"><FormattedMessage id="wanttoknow"
                                    defaultMessage="Want to Know Your Fortune?"/></h1>
                  <p className="text-big text-bold offset-top-5 offset-xs-top-10 offset-md-top-5 offset-xl-top-10"><FormattedMessage id="crackfor"
                                    defaultMessage="Crack a Fortune Cookie"/></p>
                  <a href={`/fortuneCookie?uid=${uid}`} className="swapbtn btn btn-white-outline offset-top-5 offset-xs-top-13 offset-md-top-5 offset-xl-top-13"><FormattedMessage id="knowmore"
                                    defaultMessage="Know More"/></a>
                </div>
              </div>
            </div>
            <div className="cell-xs-10 cell-sm-8 cell-md-4 offset-xs-top-30 offset-md-top-0 section-relative bg-image bg-image-5 bg-image-overlay bg-image-hover">
              
              <div className="box-offer box-offer-variant-2 context-dark">
                <div className="box-offer-caption">
                  <div className="img-icon"></div>
                  <h1 style={{fontSize:'60px'}} className="offset-top-10 offset-xs-top-20 offset-md-top-10 offset-xl-top-20"><FormattedMessage id="numbersexc"
                                    defaultMessage="Number Excites You?"/></h1>
                  <p className="text-big text-bold offset-top-5 offset-xs-top-10 offset-md-top-5 offset-xl-top-10"><FormattedMessage id="findoutmore"
                                    defaultMessage="Find more about numbers and their numerology"/> </p>
                  <a href={`/numerology?uid=${uid}`} className="swapbtn btn btn-white-outline offset-top-5 offset-xs-top-13 offset-md-top-5 offset-xl-top-13"><FormattedMessage id="knowmore"
                                    defaultMessage="Know More"/></a>
                </div>
              </div>
            </div>
          </div>
        </section>
        }
            </div>
            </div>
        );
    }
}

export default Horoscopes;



// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/horoscopes/horoscopes.js